import axios from 'axios';

// const url = `http://localhost:4000`
const url = process.env.REACT_APP_BACKEND_URL || `https://api.careerroshi.com`

export const AddPost = async (data) => {
    const res = await axios.post(`${url}/newsfeed/add`, data, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });

    return res.data;
}

export const FetchPosts = async () => {
    const res = await axios.get(`${url}/admin/newsfeeds/all`);
    
    return res;
}

export const DeletePost = async (id) => {
    const res = await axios.delete(`${url}/newsfeed/delete/${id}`);
    
    return res;
}